module.exports = __webpack_public_path__ + "763eff252130b96f044ed0bd06f13f2b.MP3";